import React, { memo, useEffect, useRef, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Form, Input, message, Modal, Spin, Upload } from 'antd'
import validator from '../../validator'
import { withRouter } from 'react-router-dom'
import RichEditor from '../../components/RichEditor/RichEditor'
import UploadFileItem from '../../components/Common/FileItemComponent/UploadFileItem'
import utils from '../../utils'
import { UploadFileListWrapper } from '../../components/CommentComponent/CommentComponentStyled'
import { TinTucRequest } from '../../requests/TinTucRequest'
import TinTucConfirmSendNotificaitonModal from '../TinTucCreatePage/TinTucConfirmSendNotificationModal'
import DraggerUploadButton from '../../components/Common/DraggerUploadButton'

const AddEditNotificationModalV2 = props => {
  const {
    open,
    setOpen,
    selectedNotificationId,
    onRefresh,
    loadingAnimationStore,
    authenticationStore,
    fileStore,
  } = props || {}

  const [notificationDetail, setNotificationDetail] = useState(null)

  const EDITOR_REF = useRef()
  const [form] = Form.useForm()

  const [fileList, setFileList] = useState([])
  const [fileListUpdate, setFileListUpdate] = useState([])
  const [editorContent, setEditorContent] = useState(null)
  const [
    isCofirmSendNotificationModalVisible,
    setConfirmSendNotificationModalVisibility,
  ] = useState(false)

  const [updateValues, setUpdateValues] = useState(null)

  const confirmUpdate = async ({ is_notification_required }) => {
    setConfirmSendNotificationModalVisibility(false)
    try {
      loadingAnimationStore.showSpinner(true)
      await TinTucRequest.update({
        ...updateValues,
        is_notification_required,
      })
      message.success('Sửa thông báo thành công!')
      setOpen(false)
      onRefresh && onRefresh()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({ files: undefined })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }
  const handleRemoveFileFromListUpdate = file_id => {
    const newFileListUpdate = fileListUpdate.filter(
      file => file.file_id !== file_id
    )
    setFileListUpdate(newFileListUpdate)
  }

  const onFinish = async values => {
    loadingAnimationStore.showSpinner(true)

    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    const fileListUpdateOrigin =
      notificationDetail &&
      notificationDetail?.attachments?.map(file => file.file_id)
    const fileListUpdateAfter =
      fileListUpdate && fileListUpdate?.map(file => file.file_id)

    try {
      const response = await Promise.all(batchUploadArr)
      let submitValues = {
        ...values,
        id: null,
        attachments_request: {
          new_items: response.map(response => response.data.file_id),
        },
        content: EDITOR_REF?.current?.editor?.getData(),
        author: {
          name_lowercase: authenticationStore.currentUser.name_lowercase,
          user_name: authenticationStore.currentUser.username,
        },
      }
      if (selectedNotificationId) {
        setUpdateValues({
          ...submitValues,
          id: selectedNotificationId,
          attachments_request: {
            new_items: response.map(response => response.data.file_id),
            remove_items: fileListUpdateOrigin?.filter(
              file => !fileListUpdateAfter.includes(file)
            ),
          },
        })
        loadingAnimationStore.showSpinner(false)
        setConfirmSendNotificationModalVisibility(true)
        return
      }
      if (!selectedNotificationId) {
        await TinTucRequest.create(submitValues)
        message.success('Tạo thông báo thành công!')
        setOpen(false)
        onRefresh && onRefresh()
      }
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const renderFileList = fileList.length !== 0 && (
    <UploadFileListWrapper>
      {fileList.map(file => (
        <UploadFileItem
          key={file.uid}
          file_id={file.uid}
          file_name={file.name}
          file_type={utils.getExtensionFile(file.name)}
          handleRemoveFileFromUploadList={() =>
            handleRemoveFileFromUploadList(file.uid)
          }
        />
      ))}
    </UploadFileListWrapper>
  )
  const renderFileListUpdate = fileListUpdate && (
    <UploadFileListWrapper>
      {fileListUpdate.map(file => (
        <UploadFileItem
          key={file.file_id}
          file_id={file.file_id}
          file_name={file.file_name}
          file_type={utils.getExtensionFile(file.file_name)}
          isDownloadFile={true}
          handleRemoveFileFromUploadList={() =>
            handleRemoveFileFromListUpdate(file.file_id)
          }
        />
      ))}
    </UploadFileListWrapper>
  )

  useEffect(() => {
    if (!open || !selectedNotificationId) return
    ;(async () => {
      try {
        loadingAnimationStore.setShowSpinInline(true)
        const res = await TinTucRequest.getById(selectedNotificationId)
        setNotificationDetail(res.data)
      } catch (error) {
        console.error(error)
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, selectedNotificationId])

  useEffect(() => {
    if (!notificationDetail) return
    setEditorContent(notificationDetail?.content)
    setFileListUpdate(notificationDetail?.attachments)
    form.setFieldsValue({
      subject: notificationDetail?.subject,
    })
  }, [notificationDetail, form])

  return (
    <Modal
      style={{
        top: 20,
      }}
      title={
        selectedNotificationId ? 'Cập nhật thông báo' : 'Tạo thông báo mới'
      }
      open={open}
      onCancel={() => {
        setOpen(false)
      }}
      footer={null}
      wrapClassName="custom-modal-wrapper"
      width={900}>
      <TinTucConfirmSendNotificaitonModal
        visible={isCofirmSendNotificationModalVisible}
        onCancel={() => setConfirmSendNotificationModalVisibility(false)}
        onConfirm={confirmUpdate}
      />
      <Spin spinning={loadingAnimationStore.showSpinInline}>
        <Form
          scrollToFirstError={true}
          form={form}
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name={'subject'}
            label={'Tiêu đề'}
            rules={[
              { required: true, message: 'Vui lòng nhập tiêu đề!' },
              { validator: validator.validateInputString },
            ]}>
            <Input placeholder={'Nhập tiêu đề'} />
          </Form.Item>
          <Form.Item label={'Nội dung'} name={'content'}>
            <RichEditor
              EDITOR_REF={EDITOR_REF}
              placeholder={'Nhập nội dung'}
              editorContent={editorContent}
            />
          </Form.Item>
          <Form.Item label={'Tài liệu đính kèm'} name={'files'}>
            <Upload.Dragger
              valuePropName={'fileList'}
              fileList={fileList}
              onChange={handleChangeFile}
              beforeUpload={() => false}
              multiple={true}
              showUploadList={false}
              className="custom-dragger-upload">
              <DraggerUploadButton />
            </Upload.Dragger>
            {renderFileList}
            {renderFileListUpdate}

            <div className="custom-modal-footer">
              <Button
                type="default"
                onClick={() => setOpen(false)}
                htmlType="reset"
                className="custom-ant-button w-160">
                Hủy bỏ
              </Button>
              <Button
                htmlType={'submit'}
                type={'primary'}
                className="custom-ant-button w-160">
                {selectedNotificationId ? 'Cập nhật' : 'Tạo mới'}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default memo(
  withRouter(
    inject(
      'fileStore',
      'loadingAnimationStore',
      'authenticationStore'
    )(observer(AddEditNotificationModalV2))
  )
)
